import { buildValidator } from "./buildValidator";

export const accountNumber = buildValidator("Enter your 16-digit account number", (value, input) => {
  const rsRequired = input?.getAttribute("rsrequired");
  if (rsRequired && /\{val:false,/.test(rsRequired) && !value) {
    return true;
  }
  return !!value && /^\d{16}$/.test(value.toString());
});
